import i18next from 'i18next';

export default function getCurrentTrimmedLocale() {
  return i18next.language.toLowerCase().substring(0, 2);
}
